const generateLineSvgId = (id: string) => `line-icon-${id}`;
const generateLineIconPathId = (id: string, prefix?: string) => `${prefix || ''}line-icon-path-${id}`;
const generateLineIconMarkerId = (id: string, prefix?: string) => `${prefix || ''}line-icon-marker-${id}`;

export { generateLineSvgId, generateLineIconPathId, generateLineIconMarkerId };
